import { Component } from '@angular/core';

@Component({
  selector: 'app-ice-info-box',
  templateUrl: './ice-info-box.component.html',
  styleUrls: ['./ice-info-box.component.scss'],
  standalone: true,
})
export class IceInfoBoxComponent {}
